var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrokenImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1418_62411",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.63265 4.38422C3.63265 3.96914 3.96914 3.63265 4.38422 3.63265H19.6158C20.0309 3.63265 20.3673 3.96914 20.3673 4.38422V10.5322L22 8.89951V4.38422C22 3.06745 20.9326 2 19.6158 2H4.38422C3.06745 2 2 3.06745 2 4.38422V19.6158C2 20.9326 3.06745 22 4.38422 22H8.89951L10.5322 20.3673H4.38422C3.96914 20.3673 3.63265 20.0309 3.63265 19.6158V4.38422ZM13.0777 20.3673L11.4451 22H19.6158C20.9325 22 22 20.9326 22 19.6158V11.4451L20.3673 13.0777V19.6158C20.3673 20.0309 20.0309 20.3673 19.6158 20.3673H13.0777ZM17.9439 15.5012L18.3699 16.0907C18.634 16.4561 18.5519 16.9664 18.1865 17.2305C17.8212 17.4946 17.3108 17.4125 17.0467 17.0471L16.7746 16.6705L17.9439 15.5012ZM16.8759 14.0236L15.7065 15.193L14.8534 14.0126L14.3333 14.728C13.8952 15.3359 12.9979 15.3348 12.5615 14.7247L10.2823 11.5372L6.32923 17.0449C6.06635 17.4112 5.55632 17.495 5.19005 17.2321C4.82378 16.9692 4.73997 16.4592 5.00286 16.0929L8.96989 10.5658C9.60788 9.65995 10.9576 9.66245 11.595 10.566L13.4522 13.1634L13.5426 13.039C14.1808 12.1362 15.5272 12.1389 16.1646 13.0396L16.8759 14.0236ZM15.0933 8.83624C15.0936 9.35094 15.5009 9.75805 16.0156 9.75805C16.5306 9.75805 16.9379 9.35068 16.9379 8.83575C16.9379 8.32083 16.5306 7.91346 16.0156 7.91346C15.5017 7.91346 15.0942 8.31991 15.0933 8.83624ZM13.4607 8.83479C13.4623 7.41981 14.5981 6.28081 16.0156 6.28081C17.4322 6.28081 18.5706 7.41914 18.5706 8.83575C18.5706 10.2524 17.4322 11.3907 16.0156 11.3907C14.599 11.3907 13.4607 10.2514 13.4607 8.83479Z",
    fill: "#6238F9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1418_62411)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#6238F9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenImage);
export default __webpack_public_path__ + "static/media/broken-image.b5ec08c8af3a8911961830c285dbeb87.svg";
export { ForwardRef as ReactComponent };